import React from "react";
import { UserDataContext } from "./UserDataContext.js";

export const useUserData = () => React.useContext(UserDataContext);
